import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, PermissionsService, HelpersService } from '@base-shared/services';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PermissionsGuard implements CanActivate {

  constructor(
    private router: Router,
    private auth: AuthService,
    private permissions: PermissionsService,
    private helpers: HelpersService,
    private translate: TranslateService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const _permission: any = next.data['permission'] || {};
    const lookUp = this.getItemId({ ...next.params, ...next.queryParams });

    const observer = new Observable<boolean>((obs) => {
      this.permissions.getSectionPermissions(_permission.type, lookUp)
        .then(authPermissions => {

          const canAccess: any = this.permissions.checkPermissions(_permission.permissions, authPermissions);

          // display message
          if (!canAccess) {
            const message = this.translate.instant('common.not-authorized');
            this.helpers.infoMessage('', message);
          }

          if (!canAccess){
            console.log('==============> registration-test');
            this.router.navigate(['/eyrus/projects']);
          }
            

          return obs.next(canAccess);
        })
        .catch(err => obs.next(false));
    });
    return observer;
  }

  /**
   * Trigger not authorized flow
   */
  notAuthorized() {
    this.router.navigate(['/eyrus']);
    return false;
  }

  private getItemId(params) {
    const validKeys = ['contractId', 'contractDefinitionId', 'projectId', 'dailyLogId', 'contractWalkthroughId'];
    const childs = [];
    let payload = {};
    const keys = Object.keys(params);
    const shouldUseLast = ['contractWalkthroughId'];
    let useLast = false;

    if (keys.indexOf('childContractId') !== -1) {
      keys.push('contractDefinitionId');
      params['contractDefinitionId'] = params['childContractId'];
    }

    if (keys.indexOf('rootContractId') !== -1 && keys.indexOf('contractId') === -1) {
      keys.push('contractId');
      params['contractId'] = params['rootContractId'];
    }

    for (let index = 0; index < keys.length; index++) {
      // if (shouldUseLast.indexOf(keys[index]) !== -1)
      //   useLast = true;

      if (validKeys.indexOf(keys[index]) !== -1) {
        payload = { [keys[index]]: params[keys[index]] };
        childs.push({ [keys[index]]: params[keys[index]] });
      }
    }

    if (childs.length)
      payload = useLast ? childs[childs.length - 1] : childs[0];

    return payload;
  }
}
